/* import __COLOCATED_TEMPLATE__ from './trend-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import {
  type TrendingTopic,
  TrendingTopicImpact,
} from 'embercom/components/reporting/automation/fin-ai-agent/analyze/topic-trends/trending-topics-data-resources';
import {
  IMPACT_TRANSLATION_KEY_MAP,
  TIME_TREND_TRANSLATION_KEY_MAP,
} from 'embercom/components/reporting/automation/fin-ai-agent/analyze/topic-trends/common';

interface Args {
  trendingTopic: TrendingTopic;
}

export default class TrendStamp extends Component<Args> {
  @service declare intl: IntlService;

  get impact() {
    return this.args.trendingTopic.impact;
  }

  get timeTrend() {
    return this.args.trendingTopic.timeTrend;
  }

  get trendStampStyling() {
    if (this.impact === TrendingTopicImpact.Positive) {
      return 'bg-success-container';
    } else if (this.impact === TrendingTopicImpact.Negative) {
      return 'bg-error-container';
    } else {
      return 'bg-neutral-container';
    }
  }

  get trendStampLabel() {
    let impactKey = IMPACT_TRANSLATION_KEY_MAP[this.impact];
    let timeTrendKey = TIME_TREND_TRANSLATION_KEY_MAP[this.timeTrend];
    return this.intl.t(
      `components.reporting.automation.fin-insights.analyse.topic-trends.trend-stamp.${impactKey}-${timeTrendKey}`,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TopicTrends::TrendStamp': typeof TrendStamp;
  }
}
